import React from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import { Info } from 'phosphor-react';

interface InfoTipProps {
  label: string;
  size?: number;
}

// Ícone ⓘ com tooltip explicativo — usado nos KPIs e atalhos.
export const InfoTip = ({ label, size = 13 }: InfoTipProps) => (
  <Tooltip
    label={label}
    fontSize="11.5px"
    hasArrow
    placement="top"
    bg="#0F172A"
    color="#F1F5F9"
    borderRadius="lg"
    px={3}
    py={2}
    maxW="230px"
    lineHeight="1.4"
    openDelay={150}
  >
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      color="#CBD5E1"
      cursor="help"
      _hover={{ color: '#7C3AED' }}
      transition="color 0.15s"
      onClick={e => e.stopPropagation()}
    >
      <Info size={size} weight="bold" />
    </Box>
  </Tooltip>
);
